module.exports = __webpack_public_path__ + "static/img/bg-fr.151e6f90.png";